let csrf = document.querySelector('meta[name="csrf-token"]').content;
const config = {
    apiUrl: process.env.MIX_APP_API_ENDPOINT,
    webUrl: process.env.MIX_APP_WEB_ENDPOINT,
    token: csrf
};
export default config;
